<template>
  <div class="row no-margin-x position-relative leaderboard-group margin-bottom-4 margin-top-4">

    <div class="col-sm-12 no-padding-x" :style="{ width: barWidth, transition: barTransition }">

      <div class="leaderboard-wrap">
        <div class="leaderboard-standby text-center" v-show="!showLeaderboard">
          <p class="h2 loading-spinner d2lWhite_txt">Fetching leaderboard data...</p>
        </div>

        <div class="leaderboard" v-if="display === 'aggregated'">
          <div class="graph-bar-wrap">
            <div v-for="(count, learnerType) in graphData" :key="learnerType" class="graph-bar" v-show="leaderboardData.length && showLeaderboard" :style="{ width: determineBarHeight(count) }">
              <span class="learner-type-label"></span>
              <div class="graph-bar-x-label">
                <span class="d2lWhite_txt">{{ learnerType }} {{ count }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="leaderboard" v-else-if="isSingleEvent()">
          <div v-for="(dataForEvent, nameOfEvent) in graphData" :key="nameOfEvent" class="graph-bar-wrap" v-show="leaderboardData.length && showLeaderboard">
            <div v-if="!isSingleEvent()" class="event-name"><span>{{ nameOfEvent }}</span></div>
            <div v-for="(count, learnerType) in dataForEvent" :key="nameOfEvent + '_' + learnerType" class="graph-bar flex items-center" :style="{ width: determineBarHeight(count) }">
              <span class="learner-type-label width-100 position-relative" :class="setBarColor(learnerType, Object.keys(dataForEvent).length - 1)">

                <div class="graph-bar-x-label text-right">
                  <span class="d2lWhite_txt">{{ learnerType }} {{ count }}</span>
                </div>
              </span>
            </div>
          </div>
        </div>

        <div class="leaderboard" v-else>
          <div class="graph-bar-wrap">
            <div v-for="(count, learnerType) in graphData" :key="learnerType" class="graph-bar flex items-center" :style="{ width: determineBarHeight(count) }">
              <span class="learner-type-label width-100 position-relative" :class="setBarColor(learnerType, Object.keys(graphData).length - 1)">

                <div class="graph-bar-x-label text-right">
                  <span class="d2lWhite_txt">{{ learnerType }} {{ count }}</span>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
 /* eslint-disable no-debugger */ 
import db from '../connection';
import globalMixin from '../mixins/global';

export default {
  data: () => ({
    leaderboardData: [],
    graphData: {},
    topCount: 0,
    showLeaderboard: false,
    learnerTypes: [],
    barColors: [ // darkest to lightest
       'chromite', 'mica', 'd2lWhite'
    ],
    barColorIndex: 0,
    nonLeaders: [],
    leaders: [],
    fetchCount: 0,
    barWidth: '100%',
    barTransition: 'none',
    listener: null
  }),

  props: {
    display: {
      type: String,
      default: ''
    }
  },

  mixins: [
    globalMixin
  ],

  beforeMount() {
    // console.log('beforeMount');
    let queryRef = this.getBaseQuery();
    
    if (this.isSingleEvent() && this.display !== 'aggregated') {
      queryRef = queryRef.where('event', '==', this.$route.params.eventId);
    }
    
    queryRef.get().then(querySnapshot => {
      // console.log('firestore get');
      const results = [];

      querySnapshot.forEach(doc => {
          const data = doc.data();
          results.push(data);
      });
      // console.log('initial get:', results);
      this.showLeaderboard = true;
      this.leaderboardData = results;
      this.buildGraph();
    });

    // this.leaderboardData = [];
  },

  watch: {
    showLeaderboard(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.barWidth = '0';
        setTimeout(() => {
          this.barWidth = '100%';
          this.barTransition = 'all 1s ease-in-out';
        }, 1);
      }
    },

    leaderboardData(newVal, oldVal) {
      // console.log('leaderboardData updated', newVal, oldVal);
      if (newVal.length === oldVal.length) {
        return;
      }

      if (this.listener) {
        // stop current listener from listening so we can instantiate a new listener; otherwise requests will start compounding
        // apparently this is how to do it according to this SO post: https://stackoverflow.com/questions/46642652/how-to-remove-listener-for-documentsnapshot-events-google-cloud-firestore
        this.listener(); 
      }

      // setup listener for new submissions
      this.listener = this.getBaseQuery()
        .where('createdAt', '>', this.leaderboardData[this.leaderboardData.length - 1].createdAt)
        .onSnapshot(querySnapshot => {
            const { docs } = querySnapshot;
            // console.log('firestore snapshot call', docs);
            
            // prevent unnecessary graph rebuilds
            if (!docs.length) return;

            const results = docs.map(doc => doc.data());
            // console.log('next result:', results);
            this.leaderboardData = [...this.leaderboardData, ...results];
            this.buildGraph();
          });
    }
  },

  methods: {
    getBaseQuery() {
      return db.collection('quizSubmissions').orderBy('createdAt', 'asc');
    },

    setBarColor(learnerType = '') {
      const leaderIndex = this.nonLeaders.indexOf(learnerType);
      let barColor = 'green';
      let barColors = this.barColors.slice();

      if ( leaderIndex !== -1 ) {
        barColor = barColors[leaderIndex] !== undefined ? barColors[leaderIndex] : barColors[0];
      }

      return `color-${barColor}_bg`;
    },

    determineBarHeight(count) {
      const value = count / this.topCount * 100;
      return `${value}%`;
    },

    sortGraphXAxis(data = {}) {
      
      const sortData = (data = {}) => {
        const labels = Object.keys(data).sort(); // sort alphabetically
        // console.log('labels', labels);
        labels.sort((a, b) => {
          return data[b] - data[a];
        }); // sort by score

        const sortedData = {};
        
        if (!labels.length) return data;
        
        labels.forEach(label => {
          if (typeof data[label] === 'object') {
            sortedData[label] = sortData(data[label]);
          } else {
            sortedData[label] = data[label];
          }
        });

        return sortedData;
      };

      const output = sortData(data);
      
      return output;
    },

    formatDataForAllEventsLeaderboard() {
      if ( ! this.leaderboardData.length ) return;

      const data = {};
      
      this.leaderboardData.forEach(entry => {
        if ( 'learnerType' in entry && ! ( entry.learnerType in data ) ) {
          data[entry.learnerType] = {};
        }

        if ( 'event' in entry && entry.event ) {
          
          if ( entry.event in data[entry.learnerType] ) {
            data[entry.learnerType][entry.event] += 1;
          } else {
            data[entry.learnerType][entry.event] = 1;
          }
          // adjust top count
          if (data[entry.learnerType][entry.event] > this.topCount) {
            this.topCount = data[entry.learnerType][entry.event];
          }
        }
      });

      return data;
    },

    formatDataCurrentEventLeaderboard() {
      
      if ( ! this.leaderboardData.length ) return;

      const data = {};

      this.leaderboardData.forEach(entry => {
        if ('event' in entry && entry.event && entry.event === this.$route.params.eventId) {
          if (!(entry.event in data)) {
            data[entry.event] = {};
          }

          if ('learnerType' in entry) {
            if (!(entry.learnerType in data[entry.event])) {
              data[entry.event][entry.learnerType] = 1;
            } else {
              data[entry.event][entry.learnerType]++;
            }
            // adjust top count
            if (data[entry.event][entry.learnerType] > this.topCount) {
              this.topCount = data[entry.event][entry.learnerType];
            }
          }
        }
      });

      return data;
    },

    formatAggregatedData() {
      if ( ! this.leaderboardData.length ) return;
      
      let data = {};

      this.leaderboardData.forEach(entry => {
        
        if ( 'learnerType' in entry ) {
          if ( ! ( entry.learnerType in data ) ) {
            data[entry.learnerType] = 0;
          }

          data[entry.learnerType] = data[entry.learnerType] + 1;
          // adjust top count
          if ( data[entry.learnerType] > this.topCount ) {
            this.topCount = data[entry.learnerType];
          }
        }
      });
      
      return data;
    },

    // sorts and separates leaders from non-leaders; helps to determine graph coloring
    determineLeader() {
      // console.log('determineLeader');
      if ( !Object.keys(this.graphData).length ) {
        return;
      }

      const data = this.isSingleEvent() ? this.graphData[this.$route.params.eventId] : this.graphData;
      const leaders = [];
      const nonLeaders = []
      
      const sortedTypesByLeader = Object.keys(data).map(key => {
        return { type: key, count: data[key] };
      }).sort((a, b) => b.count - a.count);

      sortedTypesByLeader.forEach(learner => {
        const { count, type } = learner;
        
        if (count === this.topCount) {
          leaders.push(learner);
        } else {
          nonLeaders.push(type);
        }
      });

      this.nonLeaders = nonLeaders;
      this.leaders = leaders;

      this.$emit('leader-determined', leaders);
    },

    buildGraph() {
      // console.log('buildGraph');
      // reset top count value
      this.topCount = 0;
      let data;
      // debugger
      if (this.display === 'aggregated') {
        data = this.formatAggregatedData();
      } else if (this.isSingleEvent()) {
        data = this.formatDataCurrentEventLeaderboard();
        // this.determineLeader(this.graphData[this.$route.params.eventId]);
      } else {
        // data = this.formatDataForAllEventsLeaderboard();
        data = this.formatAggregatedData();
        // this.determineLeader(this.graphData);
      }
      
      // sort data
      data = this.sortGraphXAxis(data);
      this.graphData = data;

      // determine the leader for coloring the graph
      this.determineLeader();
    }
  }
}
</script>